module.exports = __webpack_public_path__ + "media/icons/mailing-facebook@3x-38fdf204.svg";